define('score_bootstrap/Events/SearchRequestChangeEvent',["jquery"], function ($) {
    "use strict";

    function SearchRequestChangeEvent(value) {
        if (typeof value === "object") {
            $.extend(this, value);
        }
    }

    SearchRequestChangeEvent.eventName     = "SearchRequestChangeEvent";
    SearchRequestChangeEvent.queryChange   = SearchRequestChangeEvent.eventName + ":queryChange";
    SearchRequestChangeEvent.deselectFacet = SearchRequestChangeEvent.eventName + ":deselectFacet";
    SearchRequestChangeEvent.clearFacets = SearchRequestChangeEvent.eventName + ":clearFacets";
    SearchRequestChangeEvent.customDataEvent = SearchRequestChangeEvent.eventName + ":customDataEvent";
    SearchRequestChangeEvent.scrollToTopResults = SearchRequestChangeEvent.eventName + ":scrollToTopResults";

    return SearchRequestChangeEvent;
});
